var _defs, _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCzechFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "roundedFlag"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 5,
    width: 36,
    height: 26,
    rx: 4,
    ry: 4
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#roundedFlag)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 5,
    width: 36,
    height: 13,
    fill: "#EEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 18,
    width: 36,
    height: 13,
    fill: "#DC143C"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#11457E",
    d: "M0 5v26l15-13z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 5,
    width: 36,
    height: 26,
    rx: 4,
    ry: 4,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCzechFlag);
export default __webpack_public_path__ + "static/media/czech-flag.81b9ab3a4ee35fb9792cecea4b2a78a9.svg";
export { ForwardRef as ReactComponent };